function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.641 13.129a2.82 2.82 0 10-5.64 0v40.872h25.382s-.373-9.778.684-11.894c2.333-4.666 4.604-15.604 5.897-19.106.823-1.786.274-3.09-1.087-3.849-1.36-.758-3.09-.244-3.848 1.117l-4.466 8.373m-5.64-3.76V3.728a2.82 2.82 0 10-5.641 0v20.242"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.281 25.444V7.488a2.82 2.82 0 10-5.64 0v17.956M35.563 28.641V7.489a2.82 2.82 0 10-5.64 0v17.956"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13 48.712h25.383"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.21,
  cy: 51.25,
  r: 1.058,
  strokeLinecap: "square",
  strokeWidth: 1.002
}));

var SvgGlove = function SvgGlove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Glove.749198a6.svg";
export { ForwardRef as ReactComponent };